/**
 * Konuşma ve izin defterinin içe aktarımsız sabitleri (yaprak modül; entegrasyon 24 Ekim 2026).
 *
 * Neden ayrı: `list-query.ts` liste kataloğunu modül yüklenirken kurar ve bu sabitleri (izin kanalı — E2 pazarlama izni alanları;
 * konuşma durumu/önceliği) okur. Sabitler `conversations.ts` içindeyken `conversations → whatsapp-cloud → acquisition →
 * list-query → conversations` döngüsü, konuşma modülü önce yüklendiğinde (ör. E1 sözleşme testi) katalogda tanımsız değer
 * okutuyordu (`CONSENT_CHANNELS.map` → TypeError). Değerler değişmedi; `conversations.ts` bunları aynen yeniden dışa aktarır.
 */
/** İzin defterinde kanal karşılığı (kişi × kanal × amaç) */
export const CONSENT_CHANNELS = ['email', 'whatsapp', 'sms', 'phone'];
export const CONSENT_CHANNEL_LABELS = {
    email: 'E-posta',
    whatsapp: 'İş mesajlaşma',
    sms: 'Kısa mesaj',
    phone: 'Telefon',
};
/** İzin defteri kaydının geçerli durumu (`consent.ts` yeniden verir) */
export const CONSENT_STATES = ['granted', 'withdrawn', 'none'];
export const CONVERSATION_STATUSES = ['open', 'pending', 'closed'];
export const CONVERSATION_PRIORITIES = ['low', 'normal', 'high', 'urgent'];
//# sourceMappingURL=conversation-enums.js.map